import cn from "classnames";
import { gql } from "graphql-request";
import styled from "styled-components";
import { LegacyImage } from "components";
import { ImagesContainerContent } from "types/graphql/generated";

interface Props {
  className?: string;
  content: ImagesContainerContent;
}

const LogoContainer = ({
  logo,
  width,
  className = "",
}: {
  logo: ImagesContainerContent["logos"]["data"][0]["features23logo"];
  width: number;
  className?: string;
}) => {
  return (
    <div
      className={cn(className, {})}
      style={{
        width: `${logo.width}px`,
        height: `${logo.height}px`,
        maxWidth: `${(logo.width / logo.height) * width}px`,
        maxHeight: `${width}px`,
      }}
    >
      <LegacyImage transform={{ format: "svg" }} {...logo} className="Features23__logo" sizes="100px" />
    </div>
  );
};

const ImagesContainer = ({
  className = "",
  content: {
    logos,
    image: {
      data: { features23image },
    },
  },
}: Props) => {
  return (
    <StyledImagesContainer className={className}>
      <ul className="Features23__logosContainer">
        {logos.data.map(({ features23logo }, index) => {
          return (
            <li key={index}>
              <LogoContainer logo={features23logo} width={29} className="Features23__logoContainer" />
              <LogoContainer logo={features23logo} width={22.5} className="Features23__logoContainerLg" />
            </li>
          );
        })}
      </ul>
      <LegacyImage
        {...features23image}
        className="Features23__image"
        layout="fill"
        sizes="400px"
        transform={{ format: "svg" }}
      />
    </StyledImagesContainer>
  );
};

const StyledImagesContainer = styled.div`
  display: flex;
  flex-direction: column;

  .Features23__logosContainer {
    max-width: 392px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    padding: 40px;
    border: 1px solid ${({ theme }) => theme.colors.fog["30"]};
    border-radius: 8px;
  }

  .Features23__logoContainerLg {
    display: none;
  }

  .Features23__image {
    position: relative;
    width: 392px;
    height: 392px;
    margin-top: 24px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    .Features23__logosContainer {
      padding: 32px;
    }

    .Features23__logoContainer {
      display: none;
    }

    .Features23__logoContainerLg {
      display: block;
    }

    .Features23__image {
      width: 302px;
      height: 302px;
      margin-top: 18px;
    }
  }
`;

gql`
  fragment ImagesContainerContent on ComponentFeaturesFeatures23 {
    logos {
      data {
        id
        features23logo: attributes {
          src: hash
          alt: alternativeText
          width
          height
        }
      }
    }
    image {
      data {
        features23image: attributes {
          src: hash
          alt: alternativeText
        }
      }
    }
  }
`;

export { ImagesContainer };
